import React from 'react'
import axios from 'axios'
import moment from 'moment'

import './blog-feed.scss'
import { getRichText } from '../../core';

const blogUrl = 'https://www.bondcollective.com/blog?format=json-pretty'

class BlogFeed extends React.Component {
  state = {
    posts: [],
  }

  componentDidMount() {
    const {origin} = window.location

    if (origin.indexOf('localhost') > -1) {
      axios.get('http://localhost:9000/cors-proxy', {
        params: {
          url: blogUrl,
        },
      })
        .then(res => {
          const { data } = res
  
          const posts = data.items.slice().splice(0, 3)
          this.setState({ posts })
        })

      return
    }

    axios.get('/.netlify/functions/cors-proxy', {
      params: {
        url: blogUrl,
      },
    })
      .then(res => {
        const { data } = res

        const posts = data.items.slice().splice(0, 3)
        this.setState({ posts })
      })
  }

  render() {
    const { posts } = this.state
    const { editableContent } = this.props.data

    if (typeof window !== 'undefined') {
      setTimeout(() => {
        window.dispatchEvent(new Event('resize'))
      })
    }

    return (
      <div styleName='feed'>
        <div>
          {getRichText(editableContent)}
        </div>

        <div styleName="posts">
          {posts.map((item, i) => {
            const { publishOn } = item
            const date = moment(publishOn).format('MMM D, YYYY')
            
            return (
              <a styleName='post' key={i} href={item.urlId}>
                <div styleName='image' style={{
                  backgroundImage: `url(${item.assetUrl})`, 
                }} />
                <p styleName='title'>
                  {item.title}
                </p>
                <h2 styleName='date '>
                  {date}
                </h2>
                {/* <div dangerouslySetInnerHTML={{ __html: item.excerpt }} /> */}
              </a>
            )
          })}
        </div>


        <a href={`/blog`}>
          <button>
            View More Posts
          </button>
        </a>
      </div>
    )
  }
}

export default BlogFeed
